module.exports = __webpack_public_path__ + "static/img/user-Header.64f9c563.png";